import { LogLevel } from "../../Shared/hooks/useLogging/Logging-types";
import { useLogging } from "../../Shared/hooks/useLogging/useLogging";
import { AUTH_SWR_KEYS } from "../Utilities/swrKeys";
import { useCachedSWR } from "../Utilities/useCachedSWR";
// Retrieves delivery addresses data from the cache using SWR; this does not trigger a network request.
// These addresses are (currently) program, plan, and delivery schedule agnostic.
export const useDeliveryAddressesQuery = () => {
    const { datadogLog } = useLogging();
    const { data, error: fetchError, isLoading, } = useCachedSWR(AUTH_SWR_KEYS.DELIVERY_ADDRESSES, {
        onSuccess: (data) => {
            if (!data.success) {
                datadogLog("Failed to fetch delivery addresses.", LogLevel.ERROR, undefined);
                throw new Error("Something unexpected happened while loading the delivery addresses.");
            }
        },
        onError: (error) => {
            datadogLog("Failed to fetch delivery addresses.", LogLevel.ERROR, undefined, error);
        },
    });
    return { data, fetchError, isLoading };
};
